// Import dependencies
import React from 'react';

// Import components
import Title from '../../common/title/Title';
import TitleText from '../../common/titletext/TitleText';

// Import CSS & assets
import './Solution.css';


const Solution_Promoteur = () => {
    return (
        <div className="landing__solution">
            <a className="anchor" id="solution"></a>
            <div className="landing__solution_title_container">
                <Title title="Les bénéfices" />
            </div>
            <div className="landing__solution_topline_container">
                <h1 className="gradient__text">Vos études capacitaires.</h1>
                <h1 className="gradient__text">Simples. Rapides. Optimisées.</h1>
                {/* <button type="button">Essayer Maintenant</button> */}
            </div>
            <div className="landing__solution_list_container">
                <div className="landing__solution_list_item">
                    <Title title="Analyse automatique du PLU*" />
                    <p>Gagnez plusieurs heures d’étude dès la première étape<br /><span style={{fontStyle: 'italic', fontSize: '13px', lineHeight: '15px'}}>* si notre IA a analysé le PLU au préalable</span></p>
                </div>
                <div className="landing__solution_list_item">
                    <Title title="Étude capacitaire instantanée" />
                    <p>Identifiez en un clic le potentiel constructible réel</p>
                </div>
                <div className="landing__solution_list_item">
                    <Title title="Synthèse claire et exportable" />
                    <p>Valorisez vos terrains auprès de vos partenaires</p>
                </div>
                <div className="landing__solution_list_item">
                    <Title title="Interface cartographique intuitive" />
                    <p>Visualisez votre foncier en contexte urbain</p>
                </div>
                <div className="landing__solution_list_item">
                    <Title title="Mise à jour automatique des données" />
                    <p>Travaillez toujours avec des informations fiables</p>
                </div>
            </div>
        </div>
    );
};

export default Solution_Promoteur;